import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceindelhi() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Delhi',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Delhi',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Services in Delhi, catering to the transportation needs of corporate offices, IT parks, business centers, and industrial units across the city. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Delhi.',

    top: 'Top Places to Visit in Delhi with Pune Corporate Car',

"topPlaces": [
  {
    "title": "India Gate",
    "description": "India Gate is a prominent war memorial in New Delhi, built to honor the soldiers of the British Indian Army who lost their lives in World War I. Surrounded by lush lawns and wide avenues, the monument becomes a favorite spot for picnics, evening walks, and photography. The eternal flame at the Amar Jawan Jyoti adds a solemn and reflective dimension, while evening lighting enhances its majestic appearance, attracting locals and tourists alike."
  },
  {
    "title": "Red Fort",
    "description": "The Red Fort, a UNESCO World Heritage Site, is a symbol of Mughal grandeur and Delhi’s rich history. Constructed in 1639 by Emperor Shah Jahan, it showcases red sandstone architecture, intricate carvings, and massive gates. The fort hosts the annual Independence Day celebration, while visitors explore its museums, gardens, and iconic structures like Diwan-i-Aam and Diwan-i-Khas, making it a cultural and historical hub in the city."
  },
  {
    "title": "Qutub Minar",
    "description": "Qutub Minar, a UNESCO World Heritage Site, is the tallest brick minaret in the world, standing at 73 meters. Built in 1193, it features Indo-Islamic architecture with intricate carvings, inscriptions, and surrounding ancient ruins. The Qutub complex offers historical insights, serene gardens, and photographic opportunities, making it a must-visit destination for history enthusiasts and travelers."
  },
  {
    "title": "Humayun’s Tomb",
    "description": "Humayun’s Tomb is a magnificent Mughal-era mausoleum built in 1570, renowned for its Persian-style architecture, beautiful gardens, and symmetrical design. A UNESCO World Heritage Site, it is considered a precursor to the Taj Mahal. The tomb’s landscaped gardens, water channels, and serene ambiance provide visitors with a peaceful retreat in the heart of bustling Delhi."
  },
  {
    "title": "Lotus Temple",
    "description": "The Lotus Temple, also known as the Bahá’í House of Worship, is famous for its lotus-shaped architecture and tranquil surroundings. Open to people of all faiths, it offers a peaceful environment for meditation, reflection, and spiritual exploration. The pristine gardens and reflective pools around the temple enhance the serene atmosphere, making it a unique architectural and spiritual landmark in Delhi."
  },
  {
    "title": "Akshardham Temple",
    "description": "Akshardham Temple is a modern architectural marvel showcasing traditional Indian art, culture, and spirituality. The sprawling complex includes intricately carved stone temples, cultural exhibitions, musical fountains, and lush gardens. Visitors can explore exhibitions on Indian history, take boat rides illustrating India’s heritage, and enjoy the evening light and sound show, making it both an educational and spiritual experience."
  },
  {
    "title": "Connaught Place",
    "description": "Connaught Place is the heart of New Delhi’s commercial and cultural life, featuring colonial-era architecture, circular plazas, and vibrant streets filled with shops, restaurants, cafes, and offices. It is a popular destination for shopping, dining, and nightlife. The central park area hosts events and festivals, while its bustling lanes reflect the modern yet historic charm of Delhi."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid, one of India’s largest mosques, was built in 1656 by Emperor Shah Jahan. Its grand red sandstone and marble structure, wide courtyards, and towering minarets attract thousands of devotees and tourists daily. Visitors can climb the minarets for panoramic views of Old Delhi, explore the surrounding bazaars, and experience the cultural vibrancy and spiritual significance of this historic site."
  },
  {
    "title": "Raj Ghat",
    "description": "Raj Ghat is the memorial dedicated to Mahatma Gandhi, marked by a simple black marble platform set amidst peaceful gardens. It is a place of reflection and tribute, visited by people from all over India and the world. The serene surroundings and the eternal flame symbolize Gandhi’s enduring legacy, offering a moment of calm and historical reverence in the city."
  },
  {
    "title": "Lodhi Gardens",
    "description": "Lodhi Gardens is a historic park in Delhi that blends natural beauty with architectural heritage. It houses tombs of the Lodhi dynasty, beautifully landscaped gardens, walking and jogging paths, and tree-lined avenues. The park is popular with morning walkers, photographers, and families seeking leisure in a calm environment, making it one of Delhi’s most serene green spaces."
  }
],


"services": [
{
"name": "Delhi Employee Transport",
"description": "Delhi Employee Transport provides structured and reliable daily transportation services for employees working in corporate offices, industrial units, and IT parks across Delhi. The service features trained drivers, GPS-enabled vehicles, multi-shift scheduling, and optimized routes to ensure safe, punctual, and comfortable commuting for staff of all levels."
},
{
"name": "Corporate Shuttle Delhi",
"description": "Corporate Shuttle Delhi delivers organized shuttle services for corporate employees, office staff, and industrial workers. The service includes multi-passenger vans, trained chauffeurs, GPS tracking, and scheduled pick-ups and drop-offs to ensure smooth, efficient, and safe travel across the city."
},
{
"name": "Office Pickup Drop Delhi",
"description": "Office Pickup Drop Delhi offers convenient and reliable pickup and drop services for employees commuting to offices, IT parks, and industrial units. With structured routes, GPS monitoring, trained drivers, and timely operations, the service ensures hassle-free daily commuting."
},
{
"name": "Business Cab Delhi",
"description": "Business Cab Delhi provides professional cab services for corporate executives, managers, and employees. The service features well-maintained sedans and SUVs, trained drivers, GPS tracking, and punctual pickups to ensure safe, comfortable, and efficient travel for business needs."
},
{
"name": "Company Cab Service Delhi",
"description": "Company Cab Service Delhi offers reliable and structured corporate cab solutions for businesses and industrial units. The service includes trained chauffeurs, GPS-enabled vehicles, optimized routes, multi-shift support, and consistent availability to ensure seamless employee transportation."
},
{
"name": "Staff Transportation Delhi",
"description": "Staff Transportation Delhi specializes in safe and dependable commute solutions for factory and office staff. The service features multi-passenger vehicles, GPS monitoring, trained drivers, structured schedules, and multi-shift support to provide organized and punctual daily transportation."
},
{
"name": "Best Corporate Cabs Delhi",
"description": "Best Corporate Cabs Delhi delivers premium corporate transportation for executives, office employees, and industrial staff. The service ensures professional drivers, GPS-enabled vehicles, clean and comfortable sedans and SUVs, structured routes, and punctual travel for high-quality employee commuting."
},
{
"name": "Affordable Corporate Taxi Delhi",
"description": "Affordable Corporate Taxi Delhi offers budget-friendly corporate and employee transportation solutions. The service includes well-maintained vehicles, professional drivers, GPS tracking, optimized routes, and reliable pickups for safe, timely, and cost-effective commuting."
},
{
"name": "Monthly Corporate Cab Delhi",
"description": "Monthly Corporate Cab Delhi provides long-term corporate transportation solutions for companies requiring consistent employee commute services. The service includes fixed monthly plans, GPS-enabled vehicles, trained chauffeurs, structured routes, and punctual daily pickups for efficient and hassle-free commuting."
},
{
"name": "Outstation Cab Delhi",
"description": "Outstation Cab Delhi offers long-distance travel solutions for corporate employees, business trips, and industrial visits. The service includes GPS-enabled vehicles, trained drivers, optimized routes, and comfortable seating to ensure safe, timely, and reliable intercity commuting."
},
{
"name": "Sedan Corporate Cab Delhi",
"description": "Sedan Corporate Cab Delhi provides premium sedans for executives, managers, and corporate staff traveling within Delhi and surrounding regions. The service ensures professional drivers, GPS tracking, punctual pickups, and well-maintained vehicles for safe and comfortable commuting."
},
{
"name": "SUV Corporate Cab Delhi",
"description": "SUV Corporate Cab Delhi offers spacious and comfortable SUVs for team travel, industrial staff transport, and corporate commuting. The service features trained drivers, GPS-enabled vehicles, structured routes, and multi-shift support for safe and efficient transportation."
},
{
"name": "Corporate Fleet Delhi",
"description": "Corporate Fleet Delhi delivers fully managed corporate fleet solutions, including sedans, SUVs, and staff cabs. The service covers vehicle maintenance, driver management, GPS tracking, and structured routes to ensure seamless, safe, and efficient employee commuting."
},
{
"name": "Employee Commute Delhi",
"description": "Employee Commute Delhi offers structured daily transportation for office and industrial employees. The service includes trained drivers, GPS-enabled vehicles, multi-shift support, optimized routes, and punctual pickups and drop-offs to ensure safe, reliable, and comfortable commuting."
},
{
"name": "Executive Chauffeur Delhi",
"description": "Executive Chauffeur Delhi provides premium chauffeur-driven services for top management, executives, and VIPs. The service includes luxury sedans and SUVs, GPS-enabled vehicles, trained professional drivers, punctual pickups, and comfortable, secure, and reliable corporate travel."
}
],

"tableData": [
["Delhi Employee Transport", "Corporate Shuttle Delhi"],
["Office Pickup Drop Delhi", "Business Cab Delhi"],
["Company Cab Service Delhi", "Staff Transportation Delhi"],
["Best Corporate Cabs Delhi", "Affordable Corporate Taxi Delhi"],
["Monthly Corporate Cab Delhi", "Outstation Cab Delhi"],
["Sedan Corporate Cab Delhi", "SUV Corporate Cab Delhi"],
["Corporate Fleet Delhi", "Employee Commute Delhi"],
["Executive Chauffeur Delhi", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Delhi",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Delhi, ensuring efficient, safe, and seamless transportation for employees and business executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Delhi’s business districts, IT parks, and commercial hubs, helping employees reach on time every day."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs follow corporate travel standards, offering safe, courteous, and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from a wide range of sedans, SUVs, tempo travellers, and buses—each sanitized, serviced, and maintained for smooth corporate travel."
  },
  {
    "WhyChooseheading": "Custom Corporate Travel Plans",
    "WhyChoosedescription": "We offer flexible and customizable cab rental packages designed to meet the commuting needs of companies and employees across Delhi."
  },
  {
    "WhyChooseheading": "Available 24/7 for Corporate Travel",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate transportation."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, ensuring a secure and hygienic commuting experience."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel becomes hassle-free with our streamlined booking system, reliable coordination, and dedicated support for smooth operations."
  }
]



























  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Delhi?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services for companies and employees in Delhi.',
  },
  {
    question: 'What types of corporate cab services are available in Delhi?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and dedicated fleet solutions for businesses.',
  },
  {
    question: 'Do you support daily commuting for employees in Delhi?',
    answer: 'Yes, we provide optimized daily commute solutions with timely pickups and flexible shift scheduling for corporate offices in Delhi.',
  },
  {
    question: 'How can companies book corporate cab services in Delhi?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers based on employee strength and corporate requirements.',
  },
  {
    question: 'Can companies avail long-term corporate cab contracts in Delhi?',
    answer: 'Yes, we provide monthly, quarterly, and annual transportation contracts with flexible pricing and transparent terms.',
  },
  {
    question: 'Are safety and tracking features included in corporate cab services?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide multi-shift transportation for employees in Delhi?',
    answer: 'Yes, we manage transportation for multiple shifts including early morning, evening, night, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services in Delhi?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Verma',
    feedback: 'Reliable and professional corporate cab service in Delhi. Timely pickups and safe rides for our employees.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Nidhi Kapoor',
    feedback: 'Excellent corporate cab service in Delhi. Smooth commute and professional drivers made our employee transportation hassle-free.',
    rating: 5,
  },
];

































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Delhi",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-delhi.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited offers premium corporate cab services in Delhi, including employee transport, office pickup & drop, staff shuttle services, business cabs, monthly corporate cab plans, outstation trips, and executive chauffeur-driven vehicles for seamless corporate mobility.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-delhi"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Corporate Cab Services in Delhi | Employee & Business Transport</title>

  <meta
    name="description"
    content="Premium corporate cab services in Delhi including employee transport, corporate shuttle services, office pickup & drop, business cabs, monthly corporate cab plans, outstation trips, and executive chauffeur-driven vehicles for companies in Delhi."
  />

  <meta
    name="keywords"
    content="Delhi Employee Transport, Corporate Shuttle Delhi, Office Pickup Drop Delhi, Business Cab Delhi, Company Cab Service Delhi, Staff Transportation Delhi, Best Corporate Cabs Delhi, Affordable Corporate Taxi Delhi, Monthly Corporate Cab Delhi, Outstation Cab Delhi, Sedan Corporate Cab Delhi, SUV Corporate Cab Delhi, Corporate Fleet Delhi, Employee Commute Delhi, Executive Chauffeur Delhi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/56.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceindelhi;